import React from "react";
import { Component } from "react";
import SingleSlider from "./SingleSlider";

export default class Slider extends Component {

    state = {
        list1: [

            { name: 'Overview of workload by person and project' },
            { name: 'Project milestones viewable' },
            { name: 'Capacity trendline by person' },
            { name: 'Drag-and-drop task scheduling' },
            { name: 'Filtered views by role and person' },
            { name: 'Customized capacity thresholds per person' },

        ],
        list2: [
            { name: 'Option to drill into tasks for more info' },
            { name: 'Expanded timeline for planning' },
            { name: 'Hover states for individual effort stats' },
            { name: 'Multi-select bulk rescheduling' },
            { name: 'Effort in hours, points, or any value' },
            { name: 'Assign new work with the unscheduled tasks pane' }
        ],
        timerPercentage: 0,
        active: 0,

    }

    render() {
        var active = this.state.active;
        return (
            <div className='w-100  h-100 d-flex flex-column scroll-no-scrollbar'>
                <SingleSlider slideTimer={2000}>
                    <this.view1 />
                    <this.view2 />
                    {/* <this.view3 /> */}
                </SingleSlider>
            </div >
        );
    }
    view1 = () => {
        return (
            <div className="flexcb " style={{ backgroundColor: "#f1f1f1" }}>
                <div className=" w-100" style={{ objectFit: "cover", overflow: "hidden" }}>
                    <img className="w-100" src="/images/slider/4.jpg" />
                </div>
            </div>
        );
    }
    view2 = () => {
        return (
            <div className="flexcb " style={{ backgroundColor: "#f1f1f1" }}>
                <div className=" w-100" style={{  objectFit: "cover", overflow: "hidden" }}>
                    <img className="w-100" src="/images/slider/4.jpg" />
                </div>
            </div>
        );
    }
    view3 = () => {
        return (
            <div className="flexcb " style={{ backgroundColor: "#f1f1f1" }}>
                <div className=" w-100" style={{ height: "300px", objectFit: "cover", overflow: "hidden" }}>
                    <img className="w-100" src="/images/slider/3.jpg" />
                </div>
            </div>
        );
    }
}